<template>
  <div id="demo-basic-card">

    <vs-alert color="danger" title="Requested Module Not Found" :active.sync="package_not_found">
        <span>Package record with id: {{ $route.params.packageId }} not found. </span>
        <span>
            <span>Check </span><router-link :to="{name:'packages'}" class="text-inherit underline">All Packages</router-link>
        </span>
    </vs-alert>

    <div id="module-data" v-if="package_data">
        <div id="editPackageLoadingDiv" class="vs-con-loading__container">
            <vx-card :title="packageName" class="mb-base">
                <template   slot="actions">
                    <vx-tooltip text="Back to all packages" position="left">
                        <feather-icon @click="redirectToAllPackages()" icon="ChevronsLeftIcon" svgClasses="w-6 h-6 text-grey"></feather-icon>
                    </vx-tooltip>
                </template>
                <div class="vx-row">
                    <div class="vx-col sm:w-1/2 w-full mb-base">
                        Package name
                        <vs-input v-validate="'required'" name="name" ref="name" class="w-full" label="" v-model="package_data.name" />
                        <span class="text-danger text-sm" v-show="errors.has('name')">{{ errors.first('name') }}</span>
                    </div>
                    <div class="vx-col sm:w-1/2 w-full mb-2">
                        Price Type
                        <v-select v-validate="'required'" name="type" ref="type" v-model="priceType" :options="['Free','Cost']" />
                        <span class="text-danger text-sm" v-show="errors.has('type')">{{ errors.first('type') }}</span>
                    </div>
                </div>
                <div class="vx-row mb-base" v-if="priceType == 'Cost'">
                    <div class="vx-col sm:w-1/2 w-full mb-4">
                        <vs-input v-validate="'min:1|max_value:1000000'" name="cost" ref="cost" class="w-full" label="Cost" v-model="package_data.cost" />
                        <span class="text-danger text-sm" v-show="errors.has('cost')">{{ errors.first('cost') }}</span>
                    </div>
                    <div class="vx-col sm:w-1/2 w-full mb-4">
                        <vs-input v-validate="'max_value:1000000'" name="special_price" ref="special_price" class="w-full" label="Special price" v-model="package_data.special_price" />
                        <span class="text-danger text-sm" v-show="errors.has('special_price')">{{ errors.first('special_price') }}</span>
                    </div>
                </div>
                <div class="vx-row">
                    <div class="vx-col  w-full mb-4">
                        Modules
                        <treeselect v-validate="'required'" name="module_id" ref="module_id" v-model="modules_values" :multiple="true" :options="modules_options" />
                        <span class="text-danger text-sm" v-show="errors.has('module_id')">{{ errors.first('module_id') }}</span>
                    </div>
                </div>
                <div class="vx-row">
                    <div class="vx-col  w-full mb-2">
                        Description
                        <vs-textarea  v-model="package_data.description" />
                    </div>
                </div>

                <div class="vx-row">
                    <div class="vx-col w-full"  align="right">
                      <vs-button @click="validateUpdatePackage()" class="mr-3 mb-2">Save Changes</vs-button>
                    </div>
                </div>
            </vx-card>
        </div>
    </div>
  </div>
</template>

<script>
import VuePerfectScrollbar from 'vue-perfect-scrollbar'
import modulePackageManagement from '@/store/package-management/modulePackageManagement.js'
import moduleModuleManagement from '@/store/module-management/moduleModuleManagement.js'
import 'swiper/dist/css/swiper.min.css'
import { swiper, swiperSlide } from 'vue-awesome-swiper'
import vSelect from 'vue-select'
import Treeselect from '@riophae/vue-treeselect'
import '@riophae/vue-treeselect/dist/vue-treeselect.css'

export default{
    data() {
        return {
            package_data: null,
            package_not_found: false,
            swiperOption: {
                pagination: {
                    el: '.swiper-pagination'
                }
            },
            modules_values : [],
            modules_options : [],
            otherModuleType_ : null,
            packageName : null,
        }
    },
    components: {
        VuePerfectScrollbar,
        swiper,
        swiperSlide,
        vSelect,
        Treeselect,
    },
    computed: {
        priceType: {
            set: function(val) {
                this.package_data.price_type = val.toLowerCase();
            },
            get: function() {
                let type = this.package_data.price_type
                return type[0].toUpperCase() + type.slice(1);
            }
        },
    },
    methods: {
        redirectToAllPackages() {
            this.$router.push("/packages").catch(() => {})
        },
        validateUpdatePackage() {
            this.$validator.validateAll().then(result => {
                if (result) this.updatePackage()
                else{

                }
            })
        },
        updatePackage() {
            var self = this

            this.$vs.loading({
                container: '#editPackageLoadingDiv',
                scale: 0.6
            })

            let packageData = {
                id : this.package_data.id,
                name : this.package_data.name,
                price_type : this.package_data.price_type,
                cost : this.package_data.cost,
                special_price : this.package_data.special_price,
                description : this.package_data.description,
                module_id : this.modules_values,
            }

            this.$store.dispatch("packageManagement/updatePackage", packageData)
            .then(res => { 
                this.$vs.loading.close('#editPackageLoadingDiv > .con-vs-loading')

                this.$vs.notify({
                  time:4000,
                  title:'Success',
                  text: (res.data.status) ? res.data.status : 'Sussfully Updated.',
                  color:'success',
                  iconPack: 'feather',
                  icon:'icon-alert-circle'
                });
            })
            .catch(err => {
                this.$vs.loading.close('#editPackageLoadingDiv > .con-vs-loading')

                if(err.status && err.status == 422){
                    Object.keys(err.data).forEach(function(key) {
                        self.errors.add({
                            field: key,
                            msg: err.data[key][0],
                        });
                    });
                }
            })
        },
    },
    created() {
        if(!modulePackageManagement.isRegistered) {
            this.$store.registerModule('packageManagement', modulePackageManagement)
            modulePackageManagement.isRegistered = true
        }

        if(!moduleModuleManagement.isRegistered) {
            this.$store.registerModule('moduleManagement', moduleModuleManagement)
            moduleModuleManagement.isRegistered = true
        }

        const packageId = this.$route.params.packageId
        this.$store.dispatch("packageManagement/getAPackage", packageId)
            .then(res => { 
                this.package_data = res.data 
                this.packageName = res.data.name
    
                if(res.data && res.data.modules && res.data.modules.length){
                    let modules_values = [];
                    res.data.modules.forEach(function(entry) {
                        modules_values.push(entry.id,); 
                    });

                    this.modules_values = modules_values
                }

            })
            .catch(err => {
                if(err.response.status === 404) {
                    this.package_not_found = true
                    return
                }
            })

        this.$store.dispatch("moduleManagement/getAllModules")
            .then(res => { 
                let modules_options = [];
                res.data.forEach(function(entry) {
                    modules_options.push({
                        id : entry.id,
                        label : entry.name,
                    }); 
                });

                this.modules_options = modules_options
            })
            .catch(err => { 

            })
    },

}
</script>

